import * as React from "react"

const AndroidSvg = (props) => (
	<svg
		viewBox="0 0 257 94"
		xmlns="http://www.w3.org/2000/svg"
		xmlSpace="preserve"
		style={{
			fillRule: "evenodd",
			clipRule: "evenodd",
			strokeMiterlimit: 10,
		}}
		{...props}
	>
		<path
			d="M246.037 14c0-7.727-6.273-14-14-14H14C6.273 0 0 6.273 0 14v55.287c0 7.727 6.273 14 14 14h218.037c7.727 0 14-6.273 14-14V14Z"
			style={{
				fill: "none",
				stroke: "#000",
				strokeWidth: 1,
			}}
			className="shop-border"
			transform="translate(5.025 5.025)"
		/>
		<g transform="translate(28.456 23.964)">
			<path style={{
				fill: "#5FC3E4"
			}} d="M.827.122a3.664 3.664 0 0 0-.823 2.552v40.054a3.48 3.48 0 0 0 .851 2.533l.14.112 22.432-22.434v-.5L.963 0 .827.122Z" />
			<clipPath id="a">
			</clipPath>
			<g clipPath="url(#a)">
				<path
					d="M44.469 54.754 16.426 82.8 1.952 28.473 29.994.43l14.475 54.324Z"
					style={{
						fill: "url(#b)",
						fillRule: "nonzero",
					}}
					transform="translate(-11.498 -18.925)"
				/>
			</g>
		</g>
		<g transform="translate(51.862 38.911)">
			<clipPath id="c">
				<path d="M0 7.492v.523l7.478 7.487.178-.1 8.852-5.029c2.533-1.449 2.533-3.8 0-5.235L7.656.103l-.168-.1L0 7.492Z" />
			</clipPath>
			<g clipPath="url(#c)">
				<path
					style={{
						fill: "url(#d)",
					}}
					d="M0 0h19.041v15.498H0z"
					transform="translate(0 .002)"
				/>
			</g>
		</g>
		<g transform="translate(29.278 46.66)">
			<clipPath id="e">
				<path d="M0 22.593c.823.879 2.215.981 3.767.112L30.239 7.646 22.584 0 0 22.593Z" />
			</clipPath>
			<g clipPath="url(#e)">
				<path
					d="M61.295 23.688 35.236 49.747 1.479 29.69 27.538 3.631l33.757 20.057Z"
					style={{
						fill: "url(#f)",
						fillRule: "nonzero",
					}}
					transform="translate(-16.267 -14.9)"
				/>
			</g>
		</g>
		<g transform="translate(29.278 23.375)">
			<clipPath id="g">
				<path d="m0 .729 22.584 22.556 7.655-7.647L3.767.608A4.145 4.145 0 0 0 1.748 0 2.313 2.313 0 0 0 0 .729" />
			</clipPath>
			<g clipPath="url(#g)">
				<path
					d="m35.087 1.141 25.874 25.876-33.589 19.935L1.5 21.076 35.087 1.141Z"
					style={{
						fill: "url(#h)",
						fillRule: "nonzero",
					}}
					transform="translate(-16.11 -12.403)"
				/>
			</g>
		</g>
		<path
			d="M59.35 54.147 33.063 69.084c-1.468.841-2.776.785-3.618.02l-.15.14.15.121c.841.757 2.15.823 3.618-.019L59.527 54.31l-.178-.162Z"
			opacity={0.2}
		/>
		<path
			d="m68.36 49.016-9.039 5.131.168.16 8.857-5.03a3.167 3.167 0 0 0 1.888-2.617 3.25 3.25 0 0 1-1.874 2.356Z"
			opacity={0.12}
		/>
		<path
			d="M7.563 3.221 42.887 23.29a3.34 3.34 0 0 1 1.888 2.356 3.183 3.183 0 0 0-1.888-2.617L7.563 2.96c-2.533-1.449-4.59-.243-4.59 2.655v.262c0-2.9 2.056-4.085 4.59-2.655"
			style={{
				fill: "#000",
			}}
			transform="translate(25.483 21.024)"
			opacity={0.25}
		/>
		<path
			d="M8.375 15.095c.088-6.414 5.391-11.642 11.806-11.638a11.114 11.114 0 0 1 7.973 3.206l-2.243 2.244a8.081 8.081 0 0 0-5.73-2.271c-4.58.002-8.348 3.771-8.348 8.351l.001.109-.001.111c0 4.576 3.763 8.343 8.339 8.349a7.79 7.79 0 0 0 5.88-2.328 6.625 6.625 0 0 0 1.729-4h-7.6v-3.18h10.7c.119.657.175 1.324.168 1.991a10.504 10.504 0 0 1-2.758 7.431 10.643 10.643 0 0 1-8.114 3.272c-6.418.007-11.725-5.224-11.811-11.642l.009-.005Zm31.333-3.346c-4.11 0-7.492 3.382-7.492 7.492 0 4.11 3.382 7.492 7.492 7.492l.116.001c4.059 0 7.4-3.341 7.4-7.4l-.001-.101.001-.107c0-4.049-3.332-7.381-7.381-7.381l-.135.001m0 12.04c-2.342-.056-4.239-1.998-4.239-4.341 0-.067.002-.135.005-.202a4.44 4.44 0 0 1-.011-.305c0-2.327 1.914-4.241 4.241-4.241s4.241 1.914 4.241 4.241c0 .102-.004.203-.011.305.003.07.005.139.005.209 0 2.339-1.892 4.277-4.23 4.334m16.4-12.04-.129-.001c-4.049 0-7.381 3.332-7.381 7.381l.001.11c0 4.125 3.395 7.52 7.52 7.52s7.52-3.395 7.52-7.52l.001-.106c0-4.051-3.333-7.383-7.383-7.383l-.145.001-.004-.002Zm0 12.04a4.36 4.36 0 0 1-4.225-4.543 4.44 4.44 0 0 1-.011-.305c0-2.327 1.914-4.241 4.241-4.241s4.241 1.914 4.241 4.241c0 .102-.004.203-.011.305.003.068.005.136.005.204 0 2.342-1.895 4.284-4.236 4.341l-.004-.002Zm20.148-11.58v1.215h-.112a5.167 5.167 0 0 0-3.945-1.673c-3.98.184-7.154 3.508-7.154 7.492s3.174 7.308 7.154 7.492a5.087 5.087 0 0 0 3.945-1.7h.112v1.084c0 2.86-1.533 4.393-4 4.393a4.159 4.159 0 0 1-3.776-2.664l-2.87 1.2a7.165 7.165 0 0 0 6.646 4.431c3.851 0 7.123-2.281 7.123-7.815V12.2l-3.123.006Zm-3.776 11.582a4.325 4.325 0 0 1-4.169-4.515 3.91 3.91 0 0 1-.007-.242c0-2.318 1.86-4.246 4.176-4.331 2.243 0 4 1.926 4 4.571.009 2.608-1.757 4.515-4 4.515m9.17-19.536h3.29v22.034h-3.29V4.25Zm12.32 19.536a3.816 3.816 0 0 1-3.627-2.271l10.021-4.15-.346-.851a6.968 6.968 0 0 0-6.412-4.767c-3.89.025-7.077 3.232-7.077 7.122 0 .126.003.252.01.378l-.002.16c0 4.02 3.308 7.328 7.328 7.328l.105-.001a7.458 7.458 0 0 0 6.254-3.318l-2.561-1.7a4.28 4.28 0 0 1-3.693 2.072v-.002Zm-.252-9.142a2.904 2.904 0 0 1 2.776 1.589l-6.7 2.776a4.13 4.13 0 0 1 3.923-4.363l.001-.002Zm21.106-10.392h-7.88v22.032h3.29v-8.348h4.59c.083.003.167.004.25.004 3.778 0 6.905-3.068 6.976-6.846-.074-3.778-3.203-6.846-6.982-6.846-.081 0-.163.001-.244.004Zm.084 10.619h-4.674V7.318h4.735a3.794 3.794 0 0 1 3.777 3.776 3.795 3.795 0 0 1-3.777 3.778l-.061-.001m12.246-10.619h-3.29v22.032h3.29V4.252Zm14.76 21.995V17.8c0-3.907-2.916-6.095-6.693-6.095a6.192 6.192 0 0 0-5.861 3.374l2.916 1.215a3.126 3.126 0 0 1 3.01-1.608c1.692 0 3.421 1.019 3.449 2.832v.224a7.327 7.327 0 0 0-3.431-.851c-3.141 0-6.347 1.729-6.347 4.964 0 2.944 2.58 4.842 5.478 4.842a4.641 4.641 0 0 0 4.188-2.15h.112v1.7h3.179Zm-7.085-2.468c-1.075 0-2.58-.533-2.58-1.87 0-1.7 1.879-2.356 3.487-2.356a5.832 5.832 0 0 1 3.01.738 4.001 4.001 0 0 1-3.918 3.488h.001Zm18.648-11.591-3.767 9.544h-.111l-3.917-9.544h-3.543l5.87 13.348-3.346 7.422h3.431l9.039-20.77h-3.656Z"
			style={{
				fill: "#000",
			}}
			transform="translate(70.501 30.303)"
			className="shop-text"
		/>
		<defs>
			<linearGradient
				id="b"
				x1={0}
				y1={0}
				x2={1}
				y2={0}
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(-16.288 83.87) scale(9.35374)"
			>
				<stop
					offset={0}
					style={{
						stopColor: "#4595d1",
						stopOpacity: 1,
					}}
				/>
				<stop
					offset={0.01}
					style={{
						stopColor: "#4496d2",
						stopOpacity: 1,
					}}
				/>
				<stop
					offset={0.26}
					style={{
						stopColor: "#3db7ea",
						stopOpacity: 1,
					}}
				/>
				<stop
					offset={0.51}
					style={{
						stopColor: "#48c0ec",
						stopOpacity: 1,
					}}
				/>
				<stop
					offset={0.76}
					style={{
						stopColor: "#5bc2e5",
						stopOpacity: 1,
					}}
				/>
				<stop
					offset={1}
					style={{
						stopColor: "#5fc3e4",
						stopOpacity: 1,
					}}
				/>
			</linearGradient>
			<linearGradient
				id="d"
				x1={0}
				y1={0}
				x2={1}
				y2={0}
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(-51.201 48.648) scale(9.34913)"
			>
				<stop
					offset={0}
					style={{
						stopColor: "#ffdf05",
						stopOpacity: 1,
					}}
				/>
				<stop
					offset={0.41}
					style={{
						stopColor: "#fabb0c",
						stopOpacity: 1,
					}}
				/>
				<stop
					offset={0.78}
					style={{
						stopColor: "#f5a216",
						stopOpacity: 1,
					}}
				/>
				<stop
					offset={1}
					style={{
						stopColor: "#f4991a",
						stopOpacity: 1,
					}}
				/>
			</linearGradient>
			<linearGradient
				id="f"
				x1={0}
				y1={0}
				x2={1}
				y2={0}
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(-12.338 55.42) scale(9.3313)"
			>
				<stop
					offset={0}
					style={{
						stopColor: "#e73f49",
						stopOpacity: 1,
					}}
				/>
				<stop
					offset={1}
					style={{
						stopColor: "#c20f62",
						stopOpacity: 1,
					}}
				/>
			</linearGradient>
			<linearGradient
				id="h"
				x1={0}
				y1={0}
				x2={1}
				y2={0}
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(-12.473 75.721) scale(9.33538)"
			>
				<stop
					offset={0}
					style={{
						stopColor: "#319f71",
						stopOpacity: 1,
					}}
				/>
				<stop
					offset={0.07}
					style={{
						stopColor: "#2ba671",
						stopOpacity: 1,
					}}
				/>
				<stop
					offset={0.48}
					style={{
						stopColor: "#4eb16f",
						stopOpacity: 1,
					}}
				/>
				<stop
					offset={0.8}
					style={{
						stopColor: "#60b468",
						stopOpacity: 1,
					}}
				/>
				<stop
					offset={1}
					style={{
						stopColor: "#63b563",
						stopOpacity: 1,
					}}
				/>
			</linearGradient>
		</defs>
	</svg>
)

export default AndroidSvg;
